module.exports = __webpack_public_path__ + "img/may.8f246622.png";